import api from '@/services/fleet/FleetDataService'

export function HoldingSites(): any {
  const manifest = api.getManifest()
  const outTriage = {}
  const outFieldReady = {}
  for (const k in manifest) {
    if (!(k.toLowerCase().startsWith('site.'))) {
      continue
    }
    const site = manifest[k]
    const id = k.replaceAll('site.', '')
    if (!site.title) {
      continue
    }
    if (site.title.endsWith('-Triage')) {
      outTriage[site.title] = id
      continue
    }
    if (site.title.endsWith('-Field Ready')) {
      outFieldReady[site.title] = id
    }
  }
  return { ...outTriage, ...{"": ""}, ...outFieldReady, ...{" ": ""}, ...{
    "Orphaned Devices": "orphaned-devices",
    "Retired Devices": "retired-devices",
    "Device Triage Holding Area": "device-triage",
  }}
}
